import getLang from './default-lang'

const numberFormatByCurrency = {}

const EN_US_DECIMAL_FORMAT = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
})

const NBSP = String.fromCharCode(160)

interface Part {
  value: string
  type: string
}

const roundPrice = (_v: number | string, decimals = 2): number => {
  let v: number = typeof _v == 'string' ? parseFloat(_v) : _v

  const factorRound = 10 ** decimals
  const factorRound2 = 10 ** (decimals + 1)
  v = Math.round(v * factorRound2) / factorRound2
  return Math.round(v * factorRound) / factorRound
}

export const formatPriceToParts = function (
  value: number,
  currencyCode: string,
  locale: string = getLang()
): Array<Part> {
  // queremos truncar os valores para que tenham apenas 2 casas decimais (isso vai, propositalmente, arredondar para baixo valores com 3 casas decimais)
  if (value != null && value.toFixed && !value.toFixed(3).endsWith('0')) {
    value = roundPrice(value, 2)
  }

  const key = currencyCode + '-' + locale
  if (!numberFormatByCurrency[key]) {
    if (currencyCode) {
      numberFormatByCurrency[key] = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    } else {
      numberFormatByCurrency[key] = new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    }
  }

  const parts: Part[] = numberFormatByCurrency[key].formatToParts(value)

  if (locale === 'es-MX') {
    //fix burro - equipe de MX diz que o mínimo de dígitos para o separador é 1 (ex: 1,000),
    // mas a lib diz que é 2, seguindo o Unicode CLDR de es.
    // const c = currencyCode === 'MXN' ? 'MXN ' : numberFormatByCurrency[key].format(1).split('1.00')[0]
    // return currencyCode + NBSP + EN_US_DECIMAL_FORMAT.format(value)
    const numeralParts: Part[] = EN_US_DECIMAL_FORMAT.formatToParts(value)
    return parts
      .slice(
        parts.findIndex((v) => v.type === 'currency'),
        parts.findIndex((v) => v.type === 'currency') + 1
      )
      .concat({ type: 'literal', value: NBSP })
      .concat(numeralParts)
      .map((p) =>
        p.type === 'currency' && currencyCode == 'MXN'
          ? { ...p, value: 'MX$' }
          : p.type === 'currency' && currencyCode == 'USD'
          ? { ...p, value: 'US$' }
          : p
      )
  }

  if (locale && locale.startsWith('en') && currencyCode === 'USD') {
    //coloca o US$
    // return 'US$' + EN_US_DECIMAL_FORMAT.format(value)
    return parts.map((p) => (p.type === 'currency' ? { ...p, value: 'US$' } : p))
  }

  return parts
}

const printPrice = (value, currencyCode = 'USD', locale = getLang()) => {
  // value = value - (value % 0.01) || value
  return formatPriceToParts(value, currencyCode, locale)
    .map((r) => r.value)
    .join('')
}

export default printPrice
